import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState({ success: false, message: '' });

  // Detectar si viene desde hosting y pre-rellenar el mensaje
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const servicio = urlParams.get('servicio');
    
    if (servicio === 'hosting') {
      setFormData(prev => ({
        ...prev,
        mensaje: 'Hola, estoy interesado en contratar el Plan de Hosting Anual VGB por 180€/año. ¿Podrían enviarme más información y el proceso de contratación?'
      }));
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Hablemos de tu Proyecto
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Información de contacto */}
          <div>
            <h2 className="text-2xl font-semibold mb-6">
              Información de Contacto
            </h2>
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="text-red-500 mr-3 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                    <path d="M12 0C7.31 0 3.5 3.81 3.5 8.5c0 5.94 7.03 14.15 7.81 15.09.39.47 1.02.47 1.41 0 .78-.94 7.78-9.15 7.78-15.09C20.5 3.81 16.69 0 12 0zm0 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                  </svg>
                </div>
                <a 
                  href="https://maps.app.goo.gl/jT6LFzR59caoLysh7" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-blue-600"
                >
                  C.C. Nuestra Señora de África, Local 64 - Santa Cruz de Tenerife
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiIcons.FiPhone} className="h-6 w-6 text-blue-600 mr-3" />
                <a 
                  href="tel:+34922640256" 
                  className="hover:text-blue-600 flex items-center"
                >
                  <span>+34 922 640 256</span>
                  <SafeIcon icon={FiIcons.FiMessageCircle} className="ml-2 text-green-500" />
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiIcons.FiMail} className="h-6 w-6 text-blue-600 mr-3" />
                <a 
                  href="mailto:info@vgbcomputers.com" 
                  className="hover:text-blue-600"
                >
                  info@vgbcomputers.com
                </a>
              </div>
            </div>

            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                ¿Por qué Contactarnos?
              </h2>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-green-500 mr-2" />
                  <span>Asesoramiento personalizado</span>
                </li>
                <li className="flex items-center">
                  <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-green-500 mr-2" />
                  <span>Soporte técnico especializado</span>
                </li>
                <li className="flex items-center">
                  <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-green-500 mr-2" />
                  <span>Soluciones a medida</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Formulario */}
          <div>
            <h2 className="text-2xl font-semibold mb-6">
              Envíenos un Mensaje
            </h2>
            {submitResult.success ? (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                <p>¡Mensaje enviado con éxito! Nos pondremos en contacto con usted lo antes posible.</p>
              </div>
            ) : (
              <form 
                method="POST" 
                action="https://app.vgbcloud.es/webhook/1fb211f7-47aa-431b-8213-496a9d179a78"
                className="space-y-6"
              >
                <div>
                  <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
                    Nombre
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700">
                    Mensaje
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    rows={4}
                    value={formData.mensaje}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;